import { render, staticRenderFns } from "./IncomingShipment.vue?vue&type=template&id=4b37791e&scoped=true&"
import script from "./IncomingShipment.vue?vue&type=script&lang=js&"
export * from "./IncomingShipment.vue?vue&type=script&lang=js&"
import style0 from "./IncomingShipment.vue?vue&type=style&index=0&id=4b37791e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b37791e",
  null
  
)

export default component.exports